<template>
  <div class="order-list tt-custom-tab">
    <div class="search-bar seprator">
      <div>
        <el-cascader :show-all-levels="true" placeholder="工单类型" style="width:200px" v-model="form.type_id" :options="allTicketTypes" :props="{ value:'id' ,label:'name', children:'next_level_list' }"></el-cascader>
        <!--<el-select style="width:110px" v-model="form.type_id" class="mobile-select" placeholder="工单类型">
          <el-option label="工单类型" value=""></el-option>
          <el-option v-for="(p, index) in ticketTypes" :key="index" :label="p.name"
            :value="p.id"></el-option>
        </el-select>-->
      </div>
      <div>
        <el-select style="width:100px" v-model="form.priority_id" class="mobile-select" placeholder="优先级">
          <el-option label="优先级" value=""></el-option>
          <el-option v-for="(status, index) in ticketPriorities" :key="index" :label="status.name"
            :value="status.id"></el-option>
        </el-select>
      </div>
      <div>
        <el-cascader :show-all-levels="true" placeholder="指派给" style="width:200px" v-model="assignTo" :options="singleListOptions" 
        :props="{ value:'id' ,label:'name', children:'account_list',checkStrictly: true}"></el-cascader>
      </div>
      <div>
        <el-select style="width:80px;margin-right:-10px;" v-model="merchantOrExpress" class="combo-left mobile-select" @change="changeMerchatOrExpress">
          <el-option label="商家" :value="1"></el-option>
          <el-option label="转运" :value="2"></el-option>
        </el-select>
        <el-select v-if="merchantOrExpress == 1" style="width:170px;" v-model="form.merchant_id" clearable filterable :filter-method="filterSearch"
          class="combo-right input-width" placeholder="商家">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
        <el-select v-else style="width:170px;"
                          v-model="form.transport_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
          </el-select>
      </div>
      <div>
        <el-cascader :show-all-levels="true" placeholder="状态" style="width:200px" v-model="status_arr" :options="ticketStatusOptions" :props="{ value:'id' ,label:'name', children:'next_level_list' }"></el-cascader>
      </div>
      <div>
        <el-button type="primary" @click="openTicket">创建工单</el-button>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount<0?0:totalCount}}个工单&nbsp;&nbsp;
        </span>
      </div>
      <div style="display:flex;align-items:center;">
        <div style="margin-right:5px;display:flex;align-items: center;">
          <el-select style="width:110px;" v-model="timeRangeType" class="combo-left mobile-select">
            <el-option label="创建时间" :value="1"></el-option>
            <el-option label="更新时间" :value="2"></el-option>
            <el-option label="回复时间" :value="3"></el-option>
          </el-select>
          <span class="combo-right">
            <el-date-picker format="yyyy-MM-dd HH:mm" v-model="form.date_range" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </span>
        </div>
        <div>
          <el-input class="commbo-input" style="width:500px;" :placeholder="keyword_type=='0'?'工单号、主题、描述':'任务号'" clearable v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;" @change="changeKeywordType">
              <el-option label="全文搜索" value="0"></el-option>
              <el-option label="任务号" value="1"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>
    </div>
    <div v-if="totalCount > 0" class="table">
      <div class="table-head">
        <div v-for="c in columns" :style="{width:c.width}">
          {{ c.name }}
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
          <el-collapse class="customCollapse2" v-model="activeName" accordion style="width:100%;" @change="changeCollapse">
            <el-collapse-item v-for="(r,index) in mailList" :name="index" :key="index">
              <template slot="title">
                <div class="table-row-title" style="line-height:1;width:100%;">
                  <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                    <template v-if="c.field=='send_time_display'">
                      <p style="font-size: 16px;padding-bottom: 5px;">
                        <span class="priority-label" :title="ticketPriorityDisplay(r.priority_id)" :class="{'P1':ticketPriorityDisplay(r.priority_id)=='高','P2':ticketPriorityDisplay(r.priority_id)=='中','P3':ticketPriorityDisplay(r.priority_id)=='低'}"></span>
                        #{{ r.ticket_number }}
                      </p>
                    </template>
                    <template v-if="c.field=='mail_content'">
                      <p style="font-size: 16px;padding-bottom: 5px;">
                        <label style="font-size: 16px;">{{ r.subject }}</label>
                      </p>
                      <p style="color:#666;">
                        <label>
                          <i class="el-icon-collection-tag" style="font-size: 16px;position:relative;top:2px;"></i>
                          {{ ticketTypeDisplay(r.type_id) }}
                        </label>
                        <label style="margin-left:5px;">
                          <i title="指派给" class="el-icon-thumb" style="font-size: 16px;transform: rotate(90deg);position:relative;top:1px;"></i>
                          {{ ticketAccountDisplay(r) }}
                        </label>
                        <label style="margin-left:5px;">
                          <i title="更新时间" class="el-icon-time" style="font-size: 16px;position:relative;top:1px;"></i>
                          {{ r.created_date }}
                        </label>
                      </p>                      
                    </template>
                    <template v-if="c.field=='status_display'">
                      <p style="font-size: 16px;;padding-bottom: 5px;">{{ ticketStatusDisplayForTitle(r.status_id).title }}</p>
                      <p style="color:#666;">{{ ticketStatusDisplayForTitle(r.status_id).subtitle }}</p>
                    </template>
                  </div>
                </div>
              </template>
              <div class="table-row-content">
                <Ticket :r="r" :relationReset="relationReset" :index="index" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible" :exceptionTypes="exceptionTypes"
                :expressList="expressList" :merchants="merchants" :ticketPriorities="ticketPriorities" :replyTemplate="replyTemplate" 
                :singleList="singleList" :ticketTypes="ticketTypes" @reset="handleReset" @searchOrder="searchOrderHandler"></Ticket>
                <div style="clear:both;"></div>
              </div>
              <div v-if="r.relationOrder" class="table-row-seperator"></div>
              <template v-if="r.relationOrder">
                <Order
                    :showHead="false"
                    :bussinessList="bussinessList"
                    :transportStatusArray="transportStatusArray"
                    :singleList="singleList"
                    :order="r.relationOrder"
                    :isSingle="true"
                    :expressList="expressList"
                    :delegates="delegates"
                    :supportAccountList="supportAccountList"
                    :supportEditAccountList="supportEditAccountList"
                    :addressList="addressList">
                  </Order>
                </template>
            </el-collapse-item>
          </el-collapse>
        </div>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
        next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>
    <AddTicket :ticketStatus="ticketStatus" :ticketVisible="ticketVisible" :ticketPriorities="ticketPriorities" :exceptionTypes="exceptionTypes"
    :singleList="singleList" :ticketTypes="ticketTypes" :expressList="expressList" :merchants="merchants" @fetchTicket="search()"></AddTicket>
    <Empty v-if="totalCount == 0" class="empty-content" title="工单"></Empty>
  </div>
</template>

<script>
import Order from '../list/Order'
import Ticket from './TicketBody.vue'
import AddTicket from './AddTicket'
import Empty from '../snatch/Empty'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  components: {
    Order:Order,
    Ticket:Ticket,
    Empty:Empty,
    AddTicket:AddTicket
  },
  computed:{
    ticketAccountDisplay(){
      return (r)=>{
        let name = []
        if(r.assigned_to_group && r.assigned_to_group!='0')
          name.push(this.singleList.find(i=>i.id==r.assigned_to_group).name)
        if(r.assigned_to && r.assigned_to!='0')
          name.push(this.singleList.find(i=>i.id==r.assigned_to_group).account_list.find(j=>j.id==r.assigned_to).name)
        if(name.length)
          return name.join(' | ')
        else
          return '未指派'
        }
    },
    ticketTypeDisplay(){
      return (type_id)=>{
        if(type_id && type_id!='0'){
          let name=''
          for(var i=0,length=this.ticketTypes.length;i<length;i++){
            let o = this.ticketTypes[i].next_level_list.find(j=>j.id==type_id)
            if(o){
              name = o.name;
              break;
            }
          }
          return name
        }
        else
          return '未分配'
      }
    },
    ticketStatusDisplay(){
      return (status_id)=>{
        if(status_id){
          let name = ''
          for(var i=0,length=this.ticketStatus.length;i<length;i++){
            let o = this.ticketStatus.find(i=>i.id==status_id)
            if(o){
              name = o.name
              break;
            }
          }
          if(!name){
            for(var i=0,length=this.ticketStatus.length;i<length;i++){
              if(this.ticketStatus[i].next_level_list.length){
                let o_o = this.ticketStatus[i].next_level_list.find(i=>i.id==status_id)
                if(o_o){
                  name = o_o.name
                  break;
                }
              }
            }
          }
          return name
        }
        else
          return ''
        }
    },
    ticketStatusDisplayForTitle(){
      return (status_id)=>{
        if(status_id){
          let name = { title:'',subtitle:'' }
          for(var i=0,length=this.ticketStatus.length;i<length;i++){
            let o = this.ticketStatus.find(i=>i.id==status_id)
            if(o){
              name.title = o.name
              break;
            }
          }
          if(!name.title){
            for(var i=0,length=this.ticketStatus.length;i<length;i++){
              if(this.ticketStatus[i].next_level_list.length){
                let o_o = this.ticketStatus[i].next_level_list.find(i=>i.id==status_id)
                if(o_o){
                  let t = o_o.name.split('-')
                  name.title=t[0]
                  name.subtitle=t[1]
                  break;
                }
              }
            }
          }
          return name
        }
        else
          return { title:'',subtitle:'' }
        }
    },
    ticketPriorityDisplay(){
      return (priority_id)=>{
        if(priority_id)
          return this.ticketPriorities.find(i=>i.id==priority_id).name
        else
          return ''
      }
    },
  },
  data() {
    return {
      keyword_type:'0',
      relationReset:false,
      merchantOrExpress:1,
      timeRangeType:1,
      account_id:this.$localStorage.get('account_id'),
      multipleUpdating:false,
      activeName: -1,
      mailList: [],
      columns: [
        { name: '工单', field: 'send_time_display',width:'26%' },
        { name: '工单内容', field: 'mail_content',width:'calc(100% - 410px)' },
        { name: '状态', field: 'status_display',width:'150px' },
      ],
      searchWord: '',
      ticketTypes: [],
      allTicketTypes:[],
      ticketStatus: [],
      ticketStatusOptions: [],
      ticketPriorities:[],
      ticketVisible:[],
      form:{
        limit:30,
        page:1,
        type_id:'',
        status_id:'',
        priority_id:'',
        date_range:[],
        merchant_id:'',
        transport_express_id:''
      },
      totalCount:-1,
      singleList: [],
      singleListOptions: [],
      //timeRange:[],
      assignTo:[],
      merchants:[],
      merchantOptions:[],
      remoteTrasports:[],
      expressList:[],
      status_arr:[],
      exceptionTypes:[],
      replyTemplate:'',

      bussinessList:null,
      transportStatusArray:null,
      delegates:[],
      supportAccountList:[],
      supportEditAccountList:[],
      addressList:[],
    }
  },
  async mounted() {
    if(localStorage.getItem('ticketfilter_timeRange_new'))
      this.form.date_range=JSON.parse(localStorage.getItem('ticketfilter_timeRange_new'))
    /*else{
      this.form.date_range=[new Date(new Date().getTime()-3*24*3600*1000),new Date()]
    }*/
    await this.getSingleList()  
    await this.getTicketTypes()  
    await this.getTicketStatus()
    await this.getTicketPriorities()
    await this.getReplyTemplate()
    await this.getTicketVisible()
    await this.getExpressList()
    await this.getOrdersMerchants()
    await this.getExceptionTypeList()

    this.getGroupBussinessList()
    this.getTransportStatusArray()
    this.getAddressList()
    api.getShipDelegateList(this).then((res)=>{
      this.delegates=res.body.result;
    })
    api.getSupportAccountList(this).then((res)=>{
      this.supportAccountList=res.body.result;
    })
    api.getEditSupportAccountList(this).then((res)=>{
      this.supportEditAccountList=res.body.result;
    })
    this.search()
  },
  methods: {
    changeKeywordType(){

    },
    searchOrderHandler(data){
      data.ticket.relationOrder = data.order;
    },
    async getAddressList(){
      let res = await api.getAddressList(this)
      res = res.body
      this.addressList = res.result
    },
    async getTransportStatusArray () {
      let res = await api.getTransportStatusArray(this)
      this.transportStatusArray=[{id:-1, show:'预报状态'}]
      for(let p in res.body.result){
        res.body.result[p].forEach((i)=>{
          this.transportStatusArray.push({id:i.id,show:i.show,nextStep:i.nextStep,type:p})
        })
      }
    },
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
    },
    
    handleReset(){
      this.relationReset=true
    },
    async getExceptionTypeList () {   
      let res = await api.getExceptionTypeList(this)
      this.exceptionTypes=res.body.result.type_list;  
    },
    handleAssignTo(data){
      console.log('test',data)
    },
    openTicket(){
      let productCancelDialog = document.getElementById('addticket')
      productCancelDialog.click()
    },
    changeMerchatOrExpress(){
      if(this.changeMerchatOrExpress==1)
        this.form.transport_express_id=''
      else
        this.form.merchant_id=''
    },
    async getExpressList(){
      let res = await api.getExpressList(this,'')
      this.expressList=res.body.result;
    },
    remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
        }
      })
      if(callback)
          callback()
    },
    async getOrdersMerchants() {
      let res = await api.getOrdersMerchants(this, {})
      res = res.body
      this.merchants = res.result
      
    },
    filterSearch(val) {
      this.merchantOptions = []
      let mers = [];
      if (val) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    async getTicketVisible() {   
      let res = await api.getTicketVisible(this)
      this.ticketVisible=res.body.result     
    },
    async getSingleList () {   
      let res = await api.getTicketAccounts(this)
      this.singleList=res.body.result    
      this.singleListOptions=[{id:'',name:'全 部'}].concat(this.singleList) 
    },
    async getTicketStatus () {   
      let res = await api.getTicketStatus(this)
      this.ticketStatus=res.body.result
      this.ticketStatusOptions=[{id:'',name:'全 部'}]
      this.ticketStatus.forEach((t)=>{
        let tt = JSON.parse(JSON.stringify(t))
        if(t.next_level_list.length==0)
          delete tt.next_level_list
        this.ticketStatusOptions.push(tt)
      })   
    },
    async getTicketTypes(){
      let res = await api.getTicketTypes(this)
      this.ticketTypes=res.body.result   ;
      this.allTicketTypes=[{id:-1,name:'全部类型'}].concat(this.ticketTypes)
    },
    async getTicketPriorities(){
      let res = await api.getTicketPriorities(this)
      this.ticketPriorities=res.body.result    
    },
    async getReplyTemplate(){
      let res = await api.getReplyTemplate(this,)
      this.replyTemplate=res.body.result;
    },
    search(){
      const generateParams=()=>{
        let params={}
        params.limit=this.form.limit;
        params.page=this.form.page;
        if(this.form.type_id && this.form.type_id!=-1){
          params.type_id_list=[]
          params.type_id_list.push(this.form.type_id[1])
        }
        if(this.status_arr.length){
          if(this.status_arr[0]){
            params.status_id_list=[]
            this.status_arr.length>1?params.status_id_list.push(this.status_arr[1]):params.status_id_list.push(this.status_arr[0])
          }
        }
        if(this.form.priority_id){
          params.priority_id=this.form.priority_id
        }
        if(this.assignTo.length>1)
          params.assigned_to_list=[this.assignTo[1]]
        if(this.form.date_range && this.form.date_range.length){
          switch(this.timeRangeType){
            case 1:
              params.created_date_start=this.$moment(this.form.date_range[0]).format('YYYY-MM-DD HH:mm')
              params.created_date_end=this.$moment(this.form.date_range[1]).format('YYYY-MM-DD HH:mm')
              break;
            case 2:
              params.updated_date_start=this.$moment(this.form.date_range[0]).format('YYYY-MM-DD HH:mm')
              params.updated_date_end=this.$moment(this.form.date_range[1]).format('YYYY-MM-DD HH:mm')
              break;
            case 3:
              params.replied_date_start=this.$moment(this.form.date_range[0]).format('YYYY-MM-DD HH:mm')
              params.replied_date_end=this.$moment(this.form.date_range[1]).format('YYYY-MM-DD HH:mm')
              break;
          }
        }
        if(this.searchWord){
          switch(this.keyword_type){
            case '1':
              params.order_no=this.searchWord;
              break;
            default:
              params.keyword=this.searchWord;
              break;
          }
        }
        return params
      }
      localStorage.setItem('ticketfilter_timeRange_new',JSON.stringify(this.form.date_range))
      let params=generateParams()
      this.getList(params)
    },
    async changeCollapse(data){
      this.relationReset=false
      if(data==='')
        return
      let mail=this.mailList[data]
      if(mail.comments)
        return
      let params={}
      params.ticket_id=mail.id
      let res = await api.getTicketComments(this, params)
      mail.comments = res.body.result
      mail.comments.forEach((i)=>{
        i.replyDateDisplay=this.generateDateDisplay(i.replied_date.split(' ')[0])
        i.replyTimeDisplay=i.replied_date.split(' ')[1]
        i.editMode=false       
      })
      this.$set(this.mailList[data],0,mail) 
      this.$forceUpdate()
    },
    async updateMail(index){
      let mail = this.mailList[index]
      mail.updating=true
      let res=await api.updateMailInfo(this,{id_list:[mail.id],status:mail.status})
      if(res.body.status!='ok'){
        mail.status=mail.status=='1'?'2':'1'
      }
      mail.updating=false
      mail.status_display=this.mailStatus[mail.status]
      this.mailList[index]=Object.assign({},mail)
      this.$forceUpdate()
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    getList(params) {
      api.getTicketList(this, params).then((res) => {
        this.mailList = res.body.result;
        if(this.mailList){
          this.mailList.forEach((i)=>{
            if(i.created_date){
              i.createDateDisplay=this.generateDateDisplay(i.created_date.split(' ')[0])
              i.createTimeDisplay=i.created_date.split(' ')[1]
            }
          })
          if(this.activeName>-1){
            this.changeCollapse(this.activeName)
          }
        }
      })
      delete params.page
      delete params.limit
      api.getTicketListCount(this,params).then((res)=>{
        this.totalCount=+res.body.result;
      })
    },
    async getMailThemes(){
      let res = await api.getMailThemes(this)
      res = res.body
      let types = res.result
      this.mailTypes = [{name:'',label:'邮件主题'}]
      types.forEach(item => {
        this.mailTypes.push({ name: item,label: item })
      })

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.empty-content {
  padding: 50px 0 50px;
}
.tag-label{
  background:black;
  color:white;
  display: inline-block;
  height: 30px;
  padding: 0 5px;
  border-radius: 5px;
  line-height: 30px;
}
.priority-label{
    display: inline-block;
    width:16px;
    height:16px;
    border-radius: 2px;
    position: relative;
    top:3px;
    &.P1{
      background-color: #FF4650;
    }
    &.P2{
      background-color: #e6a23c;
    }
    &.P3{
      background-color: #409eff;
    }
    &.P4{
      background-color: #909399;
    }
  }
</style>

<style lang="scss">
.order-list {
  margin-bottom: 80px;

  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.table{
  margin-top:43px;
  overflow-x:auto;
  overflow-y:hidden;
  .table-head,
  .table-body{
    display: flex;
  }
  .table-head{
    padding: 18px 11px 18px 21px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
  }
  .table-row-title{
    display: flex;
  }
  .table-head{
    color:#888888;
  }
  .seporater-order{
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top:none;
      line-height: 40px;
    }
  .table-row-content{
    //display:flex;
    padding:25px 50px 30px;
    border: 1px solid #D7D7D7;
    border-top:none;
    &.order{
      display:block;
      border-top: 1px solid #D7D7D7;
    }
  }
  .table-row-seperator{
    float: left;
    height: 33px;
    width: 100%;
    border-left: 1pX dashed #D7D7D7;
    border-right: 1px dashed #D7D7D7;
  }
}
.yd-pagination{
  margin-top:30px;
}
.redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/ticket/List.vue